import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 4,
  path: '/riskManagement',
  component: Home,
  redirect: '/riskManagement/index',
  name: 'riskManagement',
  isHead: true,
  meta: {
    title: '风险管控',
    img: require('@/assets/img/sggl.png')
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/riskManagement/riskStorage/index'),
      name: 'RiskManagement',
      meta: { title: '风险管控', close: false }
      // children: [{
      //   path: 'riskStorage',
      //   component: () => import('@/views/riskManagement/riskStorage/index'),
      //   name: 'riskStorage',
      //   meta: { title: '风险库管理', close: false}
      // }, {
      //   path: 'riskRanking',
      //   name: 'riskRanking',
      //   component: () => import('@/views/riskManagement/riskRanking/index'),
      //   meta: {title: '风险分级', close: true}
      // }]
    }
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/riskManagement.js